import React from 'react';
import autobind from 'autobind-decorator';

import {ObjectUtils} from '../Utils/ObjectUtils';

export class BaseComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    @autobind
    setInitialState(state) {
        this.state = Object.assign(ObjectUtils.Clone(this.state || {}), ObjectUtils.Clone(state));
    }

    componentWillUnmount() {}

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.shouldReloadData(prevProps, prevState)) {
            this.loadData();
        }
    }

    @autobind
    shouldReloadData(prevProps, prevState) {
        return false;
    }

    @autobind
    loadData() {}
}
